import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Container,
  Image,
  Button,
  Breadcrumb,
  Form,
} from "react-bootstrap";
import FormControl from "@mui/material/FormControl";

import profile_pic from "../assets/images/profile_pic.png";
import { Get, Patch, Post } from "../Axios/AxiosFunctions";
import { apiHeader, imageUrl, pdfUrl, URL as NODE_URL } from "../Config/apiUrl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Input, MenuItem } from "@mui/material";
import Select1 from "react-select";
import upload_icon from "../assets/images/upload_icon.png";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { FaUpload } from "react-icons/fa";
import LocationInput from "../Components/LocationInput";
import Select from "@mui/material/Select";
import { BootstrapInput } from "../Components/StepperStuff";
import { countryCode } from "../Components/CountryCode";
import $ from "jquery";
import { toast } from "react-toastify";
import { updateUserRequest } from "../store/Actions/authAction";

// import CoverPhotoCompo from "./CoverPhotoCompo";

const EditProfile = ({ setfooterStyle }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const profileData = useSelector((state) => state?.authReducer?.user);
  const role = useSelector((state) => state?.authReducer?.user?.UserId?.role);
  const token = useSelector((state) => state?.authReducer?.access_token);
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);

  const [state, setstate] = useState({
    email: profileData?.UserId?.email,
    companyName: profileData?.companyName,
    contactNo: profileData?.contactNo,
    countryCode: profileData?.countryCode,
    contactPerson: profileData?.contactPerson,
    cvrNo: profileData?.cvrNo,
    description: profileData?.description,
    userName: profileData?.userName,
    photo: profileData?.photo,
    coverPhoto: profileData?.coverPhoto,
    course: profileData?.course,
    school: profileData?.school,
  });

  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");

  // CV
  const [cv, setCv] = useState(`${pdfUrl}${profileData?.cv}`);
  const [cvFile, setCvFile] = useState(null);

  const [profileImage, setProfileImage] = useState();
  const [skills, setSkills] = useState([]);
  const [skillsArray, setSkillsArray] = useState([]);
  const [certificatesArray, setCertificatesArray] = useState([]);
  const [experienceArray, setExperienceArray] = useState();
  const [educationArray, setEducationArray] = useState();

  // photo states
  const [photo, setPhoto] = useState(profileData?.photo);
  const [newPhoto, setNewPhoto] = useState(null);
  // coverPhoto states
  const [coverPhoto, setCoverPhoto] = useState(profileData?.coverPhoto);
  const [newCoverPhoto, setNewCoverPhoto] = useState(null);

  const [certificate, setCertificate] = useState([]);
  const [course, setCourse] = useState([]);
  const [education, setEducation] = useState([]);
  const [experience, setExperience] = useState([]);
  const [oldExperience, setOldExperience] = useState([]);
  const [oldEducation, setOldEductaion] = useState([]);

  const [isApiCall, setIsApiCall] = useState(false);

  const [selectedEducation, setSelectedEducation] = useState({
    education: profileData?.education,
  });
  const [selectedExperience, setSelectedExperience] = useState({
    experience: profileData?.experience,
  });

  // uploadImages
  const uploadImages = (
    event,
    setterFile,
    setterDisplay,
    c = false,
    imageValidation = false,
    pdfValidation = false
  ) => {
    if (event.target.files.length > 0) {
      // imageValidation
      if (imageValidation) {
        if (event.target.files?.length > 0) {
          if (
            !["image/jpeg", "image/png", "image/jpg"].includes(
              event.target.files[0].type
            )
          ) {
            return toast.error(
              "Please upload a valid image. [jpg and png formats only]"
            );
          }
        }
      }

      // pdfValidation
      if (pdfValidation) {
        if (event.target.files?.length > 0) {
          if (!["application/pdf"].includes(event.target.files[0].type)) {
            return toast.error(
              "Please upload a valid CV [only pdf is allowed]"
            );
          }
        }
      }

      setterFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (event) => {
        setterDisplay(event.target.result);
      };

      if (c) {
        reader.onloadend = function () {
          $(".profile_banner").css(
            "background-image",
            'url("' + reader.result + '")'
          );
        };
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const getdataSkills = NODE_URL(`admin/get-all-array`);
  const updateData = NODE_URL(`craftman/updateCraftman/${profileData._id}`);

  const getSkills = async () => {
    // console.log(getdataSkills);
    const newExperience = [];
    const newEducation = [];

    const response = await Get(getdataSkills);
    if (response == undefined) {
      toast.error("Something went wrong. Please try again later.");
      return history.goBack();
    }

    let _apiSkill = response?.data?.data?.skills;
    setSkills(_apiSkill);
    // find current skills
    let currentSkills = _apiSkill.filter((e) =>
      profileData?.skills.includes(e.skill)
    );
    setSkillsArray(currentSkills);

    let _apiCertificates = response?.data?.data?.certificates;
    setCertificate(_apiCertificates);
    // find current certificates
    const currentCertificates = _apiCertificates.filter((e) =>
      profileData?.certificates?.includes(e?.jobCertificate)
    );
    setCertificatesArray(currentCertificates);

    setCourse(response?.data?.data?.course);

    let _apiEducation = response?.data?.data?.education;
    setEducation(_apiEducation);
    setOldEductaion([{ education: profileData?.education }]);

    setExperience(response?.data?.data?.experience);
    setOldExperience([{ experience: profileData?.experience }]);

    response?.data?.data?.educations?.map((t) => {
      newEducation.push({ education: t });
    });
    response?.data?.data?.experience?.map((t) => {
      newExperience.push({ experience: t });
    });
    setEducationArray(newEducation);
    setExperienceArray(newExperience);

    // console.log("experience" , newExperience)
  };

  useEffect(() => {
    // getProfileData();
    // const newSkill = [];
    // const newCertificates = [];
    // console.log(profileData);

    // profileData?.skills.map((t) => {
    //   newSkill.push({ skill: t });
    // });
    // profileData?.certificates.map((t) => {
    //   newCertificates.push({ jobCertificate: t });
    // });
    // profileData?.certificates.map((t) => {
    //   newCertificates.push({ jobCertificate: t });
    // });

    // setOldExperience({ experience: profileData?.experience });
    // setOldEductaion({ education: profileData?.education });

    // setSkillsArray(newSkill);
    // setCertificatesArray(newCertificates);
    role !== "company" && getSkills();
  }, []);

  const handleChange = (e) => {
    // console.log(e);
    const { name, value } = e.target;

    // console.log(name, value);
    setstate({ ...state, [name]: value });
  };
  const handleDropDown = (updateArrayName, data) => {
    // console.log("old Array", data)
    updateArrayName(data);
    // console.log(data)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // var skillToGo = [];

    // for (var i = 0; i < skills.length; ++i) skillToGo.push(skills[i]["skill"]);

    var certificatesRequired = [];

    for (var i = 0; i < certificatesArray.length; ++i)
      certificatesRequired.push(certificatesArray[i]["jobCertificate"]);
    var skillTogo = [];

    for (var i = 0; i < skillsArray.length; ++i)
      skillTogo.push(skillsArray[i]["skill"]);

    const data = {
      ...state,
      certificate: certificatesRequired,
      skills: skillTogo,
      education: oldEducation.education,
      experience: oldExperience.experience,
    };

    const response = await Patch(updateData, data);
    console.log(response);
  };

  // geocoding
  useEffect(() => {
    if (address !== "") {
      var city = "";
      for (var i = 0, len = address.address_components.length; i < len; i++) {
        var ac = address.address_components[i];
        if (ac.types.indexOf("locality") >= 0) city = ac.long_name;
      }

      //only report if we got Good Stuff
      if (city != "") {
        setCity(city);
      }
    }
  }, [address]);

  // handleCompanyParams
  const handleCompanyParams = (e) => {
    e.preventDefault();
    const params = {
      companyName: state.companyName?.trim(),
      address: address ? address?.formatted_address : profileData?.address,
      contactNo: state.contactNo?.trim(),
      contactPerson: state.contactPerson?.trim(),
      countryCode: state.countryCode?.trim(),
      cvrNo: state.cvrNo?.trim(),
      description: state.description?.trim(),
      photo: newPhoto != null ? newPhoto : profileData?.photo,
      coverPhoto:
        newCoverPhoto != null ? newCoverPhoto : profileData?.coverPhoto,
      // lat lng
      lat: address ? address?.geometry?.location?.lat() : profileData?.lat,
      lng: address ? address?.geometry?.location?.lng() : profileData?.lng,
      city: address ? city : profileData?.city || "-",
    };

    // validate
    for (let key in params) {
      if (params[key] == "" || params[key] == null) {
        return toast.warn(
          `${key.replace(/([a-z])([A-Z])/g, "$1 $2")} can not be empty.`
        );
      }
    }

    // create form
    const formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    profileUpdateHandler(formData);
  };

  // handleCraftmanParams
  const handleCraftmanParams = (e) => {
    e.preventDefault();
    const params = {
      userName: state.userName?.trim(),
      address: address ? address?.formatted_address : profileData?.address,
      contactNo: state.contactNo?.trim(),
      countryCode: state.countryCode?.trim(),
      school: state.school?.trim(),
      course: state.course?.trim(),
      description: state.description?.trim(),
      photo: newPhoto != null ? newPhoto : profileData?.photo,
      // lat lng
      lat: address ? address?.geometry?.location?.lat() : profileData?.lat,
      lng: address ? address?.geometry?.location?.lng() : profileData?.lng,
      city: address ? city : profileData?.city || "-",
      education: selectedEducation?.education,
      experience: selectedExperience?.experience,
      cv: cvFile != null ? cvFile : profileData?.cv,
    };

    let _skills = skillsArray.map((e) => e.skill);
    let _certificates = certificatesArray.map((e) => e.jobCertificate);

    // validate
    for (let key in params) {
      if (params[key] == "" || params[key] == null) {
        return toast.warn(
          `${key.replace(/([a-z])([A-Z])/g, "$1 $2")} can not be empty.`
        );
      }
    }

    if (_skills?.length === 0) {
      return toast.warn("Please select atleast one skill.");
    }
    if (_certificates?.length === 0) {
      return toast.warn("Please select atleast one certificates.");
    }

    // create form
    const formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    _skills.forEach((e) => {
      formData.append("skills[]", e);
    });
    _certificates.forEach((e) => {
      formData.append("certificates[]", e);
    });

    profileUpdateHandler(formData);
  };

  // profileUpdateHandler
  const profileUpdateHandler = async (params) => {
    const url = NODE_URL("general/updateMe");

    setIsApiCall(true);
    const response = await Post(url, params, apiHeader(token, true));
    setIsApiCall(false);

    if (response !== undefined) {
      toast.success("Profile updated successfully.");
      dispatch(updateUserRequest(response?.data?.data?.user));
      role == "user" ? history.push("/profile") : history.push("/dashboard");
    }
  };

  // to scroll top up when page refreshed
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <Container className="small_container">
        <form
          onSubmit={
            role == "company" ? handleCompanyParams : handleCraftmanParams
          }
        >
          <Row>
            {/* Profile Pic of user */}
            {role !== "company" && (
              <>
                <Col lg={12} md={12}>
                  <div className="d-flex a-center j-center mt-5">
                    <div
                      className="profile_pic_div"
                      style={{ marginLeft: "0px" }}
                    >
                      <div
                        className={`profile_pic_innerdiv ${
                          role == "user" && "image-center-negative"
                        }`}
                      >
                        {newPhoto !== null ? (
                          <img
                            src={photo}
                            alt=""
                            className="img-fluid back_end_pic"
                          />
                        ) : (
                          <img
                            src={
                              newPhoto == null ? `${imageUrl}${photo}` : photo
                            }
                            alt=""
                            className="img-fluid back_end_pic"
                          />
                        )}
                        <label class="profile_pic_icon ">
                          <div className="d-flex j-center a-center upload_btns">
                            <CameraAltIcon />
                          </div>
                          <input
                            type="file"
                            size="60"
                            class="file_upload_form3rd"
                            onChange={(e) =>
                              uploadImages(
                                e,
                                setNewPhoto,
                                setPhoto,
                                false,
                                true
                              )
                            }
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="upload-cv-contaner">
                    <label className="upload-cv-contaner-btn">
                      <div className="d-flex j-center a-center upload_btns">
                        <p className="upload_btns-para">
                          {`${cvFile ? cvFile?.name : "Upload CV"}`}
                        </p>
                        <FaUpload />
                      </div>
                      <input
                        type="file"
                        accept="application/pdf,application/vnd.ms-excel"
                        size="5"
                        class="file_upload_form3rd"
                        onChange={(e) =>
                          uploadImages(e, setCvFile, setCv, true, false, true)
                        }
                      />
                    </label>
                  </div>
                </Col>
                <Col lg={12} className="show-cv-btn">
                  {/* Show Cv */}
                  <Button
                    onClick={() =>
                      cvFile != null
                        ? window.open(URL.createObjectURL(cvFile, "_blank"))
                        : window.open(cv, "_blank")
                    }
                  >
                    Show CV
                  </Button>
                </Col>
              </>
            )}
            {role == "company" && (
              <Col
                lg={12}
                className="profile_banner mt-4"
                style={{
                  backgroundImage:
                    newCoverPhoto == null
                      ? `url(${imageUrl}${coverPhoto})`
                      : coverPhoto,
                }}
              >
                {/* Profile */}
                <div className="profile_pic_div">
                  <div
                    className={`profile_pic_innerdiv ${
                      role == "user" && "image-center-negative"
                    }`}
                  >
                    {newPhoto !== null ? (
                      <img
                        src={photo}
                        alt=""
                        className="img-fluid back_end_pic"
                      />
                    ) : (
                      <img
                        src={newPhoto == null ? `${imageUrl}${photo}` : photo}
                        alt=""
                        className="img-fluid back_end_pic"
                      />
                    )}
                    <label class="profile_pic_icon ">
                      <div className="d-flex j-center a-center upload_btns">
                        <CameraAltIcon />
                      </div>
                      <input
                        type="file"
                        size="60"
                        class="file_upload_form3rd"
                        onChange={(e) =>
                          uploadImages(e, setNewPhoto, setPhoto, false, true)
                        }
                      />
                    </label>
                  </div>
                </div>
                {/* Change Cover */}

                <label className="profile_pic_icon">
                  <div className="d-flex j-center a-center upload_btns">
                    <CameraAltIcon />
                  </div>
                  <input
                    type="file"
                    size="60"
                    class="file_upload_form3rd"
                    onChange={(e) =>
                      uploadImages(e, setNewCoverPhoto, setCoverPhoto, true)
                    }
                  />
                </label>
              </Col>
            )}
          </Row>
          <div className="col_eight_setting mt-5">
            {/* Both */}
            <Row>
              <Col md={6}>
                <h5 className="font-26">
                  {role == "company" ? "Company Name" : "User Name"}
                </h5>
                <Form.Control
                  id="floatingInputCustom"
                  type="text"
                  name={role == "company" ? "companyName" : "userName"}
                  value={role == "company" ? state.companyName : state.userName}
                  required
                  onChange={handleChange}
                  placeholder={role == "company" ? "Company Name" : "User Name"}
                  className="mb-3"
                />
              </Col>
              <Col md={6}>
                <h5 className="font-26">Email</h5>
                <Form.Control
                  disabled
                  id="floatingInputCustom"
                  type="email"
                  name="email"
                  value={state.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="mb-3"
                />
              </Col>
            </Row>
            {/* Both */}
            <Row>
              <Col md={6}>
                <h5 className="font-26">Location</h5>
                <div className="new_loc_css">
                  <LocationInput
                    setPlace={setAddress}
                    val={profileData?.address}
                  />
                </div>
              </Col>
              <Col md={6}>
                <h5 className="font-26">Contact No.</h5>
                <div className="d-flex j-between">
                  <div className="step_form_col_one">
                    <FormControl variant="standard">
                      <Select
                        className="drop1_new"
                        labelId="demo-customized-select-label"
                        id="demo-customized-select"
                        value={state.countryCode}
                        name="countryCode"
                        onChange={handleChange}
                        defaultValue="value"
                        input={<BootstrapInput />}
                      >
                        {countryCode.map((item, i) => {
                          i == 0 && console.log(item);
                          return (
                            <MenuItem key={i} value={item.dial_code}>
                              <i
                                className={`flag flag-${(item?.code).toLowerCase()}`}
                              ></i>
                              {item.dial_code}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="step_form_col_three">
                    <Form.Control
                      type="text"
                      placeholder="Mobile Number"
                      value={state?.contactNo}
                      name="contactNo"
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            {role == "company" && (
              <Row>
                <Col md={6}>
                  <h5 className="font-26">CVR No</h5>
                  <Form.Control
                    id="floatingInputCustom"
                    type="text"
                    name="cvrNo"
                    value={state.cvrNo}
                    required
                    onChange={handleChange}
                    placeholder="CVR No"
                    className="mb-3"
                  />
                </Col>
              </Row>
            )}
            {role !== "company" && (
              <Row>
                <Col md={6}>
                  <h5 className="font-26">Course</h5>
                  <Form.Control
                    id="floatingInputCustom"
                    type="text"
                    name="course"
                    value={state.course}
                    required
                    onChange={handleChange}
                    placeholder="Course"
                    className="mb-3"
                  />
                </Col>
                <Col md={6}>
                  <h5 className="font-26">School</h5>
                  <Form.Control
                    id="floatingInputCustom"
                    type="text"
                    name="school"
                    value={state.school}
                    required
                    onChange={handleChange}
                    placeholder="School"
                    className="mb-3"
                  />
                </Col>
              </Row>
            )}
            {/* Both */}
            <Row>
              <h5 className="font-26">Summary</h5>

              <Col md={12} className="mb-3">
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Description here"
                  onChange={handleChange}
                  name="description"
                  value={state.description}
                />
              </Col>
            </Row>
            {/* !Company */}
            {role !== "company" && (
              <>
                <Row>
                  <h5 className="font-26">Skills</h5>

                  <Col md={12} className="mb-3">
                    <Select1
                      isMulti
                      name="colors"
                      getOptionLabel={(option) => option.skill}
                      getOptionValue={(option) => option.skill}
                      onChange={(data) => {
                        return handleDropDown(setSkillsArray, data);
                      }}
                      value={skillsArray}
                      options={skills}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </Col>
                </Row>
                <Row>
                  <h5 className="font-26">Certificates</h5>

                  <Col md={12} className="mb-3">
                    <Select1
                      isMulti
                      name="colors"
                      getOptionLabel={(option) => option.jobCertificate}
                      getOptionValue={(option) => option.jobCertificate}
                      onChange={(data) => {
                        return handleDropDown(setCertificatesArray, data);
                      }}
                      value={certificatesArray}
                      options={certificate}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </Col>
                </Row>
                <Row>
                  <h5 className="font-26">Education</h5>

                  <Col md={12} className="mb-3">
                    <Select1
                      name="colors"
                      getOptionLabel={(option) => option.education}
                      getOptionValue={(option) => option.education}
                      defaultValue={selectedEducation}
                      onChange={(data) => {
                        setSelectedEducation(data);
                      }}
                      value={selectedEducation}
                      options={educationArray}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </Col>
                </Row>
                <Row>
                  <h5 className="font-26">Experience</h5>
                  <Col md={12} className="mb-3">
                    <Select1
                      name="colors"
                      getOptionLabel={(option) => option.experience}
                      getOptionValue={(option) => option.experience}
                      onChange={(data) => {
                        setSelectedExperience(data);
                        // setSelectedExperience(data?.experience);
                      }}
                      value={selectedExperience}
                      options={experienceArray}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row>
              <Col className="text-center">
                <Button
                  type="submit"
                  disabled={isApiCall}
                  onClick={(e) =>
                    role == "company"
                      ? handleCompanyParams(e)
                      : handleCraftmanParams(e)
                  }
                >
                  {isApiCall ? "Please Wait..." : "Save Changes"}
                </Button>
              </Col>
            </Row>
          </div>
        </form>
      </Container>
    </div>
  );
};

export default EditProfile;
